/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Patient/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'



/** @type {import('Simple/types.js').View} */
export default function Patient({
  children,
  viewPath = "/DesignSystem/TasksFilters/Patient",
  setOuterRef,
  left,
  top,
  setInnerRef
  
}) {
  let flow = fromFlow.useFlow()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let filtersPatientsValueData = fromData.useDataValue({ viewPath,
context: 'filters',
path: 'patients',
})
let aggregateData = fromHelpers.getLabel(filtersPatientsValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 innerRef={setOuterRef}
 onClick={flow.has(fromFlow.normalizePath(viewPath, 'Content')) ? () => setFlowTo(fromFlow.normalizePath(viewPath, 'No')) : () => setFlowTo(fromFlow.normalizePath(viewPath, 'Content'))}
>
{childProps => (
<React.Fragment>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 marginLeft={dtSpaceXxs}
 marginRight={dtSpaceXxs}
 data="filters.patients"
 aggregate="./helpers.js getLabel"
 text={aggregateData}
/>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconArrowDown
{...childProps}
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 fill2={dtColorsNeutral700}
 width={12}
/>
)}
</TysiaButtonIcon>
</React.Fragment>
)}
</TysiaButton>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 left={left}
 top={top}
 innerRef={setInnerRef}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}